export const inr = amount => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(amount);
export function calculateSubscription(catalog, tierId, selected = [], annual = false) {
  const tier = catalog.tiers.find(item => item.id === tierId);
  if (!tier) throw new Error('Select a valid membership tier');
  const addons = catalog.addons.filter(item => selected.includes(item.id));
  const monthlyPaise = Math.round(tier.monthly * 100) + addons.reduce((sum, item) => sum + Math.round(item.monthly * 100), 0);
  const yearlyPaise = monthlyPaise * 12;
  const savingPaise = annual ? Math.round(yearlyPaise * catalog.annualDiscountPercent / 100) : 0;
  const total = (annual ? yearlyPaise - savingPaise : monthlyPaise) / 100;
  return { tier, addons, monthly: monthlyPaise / 100, savings: savingPaise / 100, total, effectiveMonthly: annual ? total / 12 : total };
}
